<template>
    <div id="summary_overview">
        <!-- <div class="container"> -->
            <div id="summary_table">
                <div class="heading">Pipeline Summary Values</div>

                <div class="body">
                    <div class="table">
                        <div class="head">
                            <div>Sales Stage<span>#ISO</span></div>
                            <div>Total</div>
                            <div>Adjusted</div>
                        </div>

                        <div class="body">
                            <div 
                                v-for="(columnData, index) in summaryTableData"
                                v-bind:key="index"
                                class="row"
                            >
                                <div>{{ columnData.name }}<span>{{ columnData.post_count }}</span></div>
                                <div>{{ formatMoneyValue(columnData.total.$numberDecimal) }}</div>
                                <div>{{ formatMoneyValue(columnData.total.$numberDecimal * columnData.percentage.$numberDecimal ) }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="targets">
                <div class="head">Pipeline Targets</div>

                <div class="target">
                    <div class="heading">Adjusted Pipeline Value v Target</div>

                    <div class="col">
                        <div>Current</div>
                        <div>{{ formatMoneyValue(totalAdjustedValue) }}</div>
                    </div>

                    <div class="col">
                        <div>Target</div>
                        <div>{{ formatMoneyValue(targets.value) }}</div>
                    </div>

                    <div class="col">
                        <div>Until Target</div>
                        <div>{{ formatMoneyValue(targets.value - totalAdjustedValue) }}</div>
                    </div>
                </div>

                <hr>

                <div class="target">
                    <div class="heading">Individual Sales Opportunities (ISO) v Target</div>
   
                    <div class="col">
                        <div>Current</div>
                        <div>{{ totalOpportunities }}</div>
                    </div>

                    <div class="col">
                        <div>Target</div>
                        <div>{{ targets.opportunities }}</div>
                    </div>

                    <div class="col">
                        <div>Until Target</div>
                        <div>{{ targets.opportunities - totalOpportunities }}</div>
                    </div>
                </div>
            </div>

            <AppCharts />
        </div>
    <!-- </div> -->
</template>

<script>
    import { mapGetters } from 'vuex';
    import axios from 'axios';
    import AppCharts from './AppCharts';
    // import SummaryTable from './SummaryTable';

    export default {
        name: 'SummaryOverview',
        components: {
            AppCharts,
            // SummaryTable
        },
        data() {
            return {
                targets: []
            }
        },
        mounted() {
            this.getTargets();
        },
        computed: {
            ...mapGetters([
                'summaryTableData', 
                'totalAdjustedValue',
                'totalOpportunities'
            ]),
        },
        methods: {
            formatMoneyValue(value) {
                return new Intl.NumberFormat('en-GB', { 
                    style: 'currency', 
                    currency: 'GBP',
                    maximumFractionDigits: value > 99.9 ? 0 : 2,
                    minimumFractionDigits: value > 99.9 ? 0 : 2,
                }).format(value);
            },
            getTargets() {
                axios.get('api/summary-board/targets')
                    .then((result) => {
                        this.targets = result.data;
                    })
                    .catch(err => console.log(err));
            }
        }
    }
</script>

<style lang="scss" scoped>
    #summary_overview{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding: 0 5rem 5rem 5rem;
        border-bottom: 0.2rem solid $primary-two;

            #summary_table{
                width: 45%;
                // width: 100%;
                background-color: #ffffff;
                border-radius: .5rem;
                overflow: hidden;
                box-shadow: 2px 2px 5px 0px rgba(0, 0, 0, 0.2);

                @media only screen and (max-width: 1800px) {
                    width: 48%;
                }

                @media only screen and (max-width: 1600px) {
                    width: 100%;
                    margin-bottom: 4rem;
                }

                .table{
                    margin: 2rem;
                    border: 0.1rem solid $primary-two;
                    border-radius: 0.5rem;

                    .head{
                        display: flex;
                        background-color: $primary-two;

                        div{
                            font-size: 2rem;
                            font-weight: 500;
                            color: #fff;
                            line-height: 1.3;
                            width: 25%;
                            padding: .5rem 1.5rem;
                            text-align: center;

                            &:nth-of-type(1){
                                width: 50%;
                                text-align: left;
                                padding: .5rem 1.5rem .5rem 3rem;

                                span{
                                    float: right;
                                    font-weight: 300;
                                }
                            }
                        }
                    }

                    .body{
                        .row{
                            display: flex;
                            border-bottom: 0.1rem solid $primary-two;

                            &:nth-of-type(1){
                                div:first-of-type{
                                    border-left: 1.5rem solid #83dd1a;
                                }
                            }

                            &:nth-of-type(2){
                                div:first-of-type{
                                    border-left: 1.5rem solid #d5d814;
                                }
                            }

                            &:nth-of-type(3){
                                div:first-of-type{
                                    border-left: 1.5rem solid #fdab2f;
                                }
                            }

                            &:nth-of-type(4){
                                div:first-of-type{
                                    border-left: 1.5rem solid #1ad4dd;
                                }
                            }

                            &:nth-of-type(5){
                                div:first-of-type{
                                    border-left: 1.5rem solid #0063e8;
                                }
                            }

                            &:nth-of-type(6){
                                div:first-of-type{
                                    border-left: 1.5rem solid #7c0aa5;
                                } 
                            }

                            &:nth-of-type(7){
                                div:first-of-type{
                                    border-left: 1.5rem solid #dd1aa1;
                                }               
                                border-bottom: 0;
                            }
                            
                            div{
                                font-size: 2rem;
                                font-weight: 300;
                                color: $primary-one;
                                line-height: 1.3;
                                padding: 0.5rem 1.5rem;
                                width: 25%;
                                text-align: center;

                                &:nth-of-type(1){
                                    width: 50%;
                                    text-align: left;

                                    span{
                                        float: right;
                                    }
                                }

                                &:nth-of-type(2){
                                    border-right: 0.1rem solid $primary-two;
                                    border-left: 0.1rem solid $primary-two;
                                }
                            }
                        }
                    }
                }

                .heading{
                    background-color: $primary-two;
                    padding: 1.5rem;
                    font-size: 2.4rem;
                    font-weight: 700;
                    color: #fff;
                    line-height: 1.3;
                    text-align: center;
                }
            }

            #targets{
                display: flex;
                flex-direction: column;
                width: 45%;
                border-radius: .5rem;
                box-shadow: 2px 2px 5px 0px rgba(0, 0, 0, 0.2);
                background-color: #fff;
                overflow: hidden;

                @media only screen and (max-width: 1800px) {
                    width: 48%;
                }

                @media only screen and (max-width: 1600px) {
                    width: 100%;
                }

                .head{
                    background-color: $primary-two;
                    padding: 1.5rem;
                    font-size: 2.4rem;
                    font-weight: 700;
                    color: #fff;
                    line-height: 1.3;
                    text-align: center;
                }
                
                hr{
                    width: 100%;
                    margin: 0;
                    border: 0;
                    border-top: 0.1rem solid $primary-two;
                }

                .target{
                    display: flex;
                    flex-wrap: wrap;
                    padding: 1.5rem;
                    height: 50%;

                    &:nth-of-type(1){
                        border-bottom: 0.1rem solid $primary-one;
                    } 

                    .heading{
                        font-size: 2rem;
                        font-weight: 700;
                        color: $primary-one;
                        line-height: 1.3;
                        width: 100%;
                        margin-bottom: 3rem;
                        margin-top: auto;
                    }

                    .col{
                        width: 33.33333%;
                        margin-bottom: auto;

                        div{
                            &:nth-of-type(1){
                                font-size: 1.6rem;
                                font-weight: 500;
                                color: $primary-one;
                                line-height: 1.3;
                            }

                            &:nth-of-type(2){
                                font-size: 2.4rem;
                                font-weight: 500;
                                color: $primary-one;
                                line-height: 1.3;
                            }
                        }
                    }
                }
            }
        }

</style>